// _typing-target.js — coord ASK-180 §3.11 item 4 (K-COM D3): ONE focus rule for every window-level key handler.
// A key whose target is an editable field belongs to that field: the stage never walks (WASD), opens the gesture radial (G),
// takes a door (E / Enter) or adds to the basket (B) on a keystroke typed into an input. The pay sheet typed "please ignore"
// and the stage received "g" (K-COM, §3.10a fixed-in-pass a) — each sheet stopping its own events is the belt; this is the
// rule. Pure: no DOM globals needed (a node-side test passes plain objects).
const EDITABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);
/** True when `target` takes typed text: input · textarea · select · any contenteditable element. */
export function isEditableTarget(target) {
	if (!target || typeof target !== "object") return false;
	if (target.isContentEditable === true) return true;
	const tag = typeof target.tagName === "string" ? target.tagName.toUpperCase() : "";
	return EDITABLE_TAGS.has(tag);
}
